import type {
  AnyFailure,
  PersonListResponse,
  PersonListSuccess,
} from "@b2bportal/air-booking-api";
import { PassengerErrorModalTypes } from "@checkout/types";
import { fetchUserPassengers } from "@hopper-b2b/api";

export const fetchUserPassengersService = () =>
  new Promise((resolve, reject) => {
    fetchUserPassengers({})
      .then((response: PersonListResponse) => {
        if ((response as AnyFailure).errors) {
          reject({
            type: PassengerErrorModalTypes.FetchPassengers,
            data: (response as AnyFailure).errors,
          });
        } else {
          resolve((response as PersonListSuccess).value);
        }
      })
      .catch((e) => {
        reject({
          type: PassengerErrorModalTypes.FetchPassengers,
          data: e,
        });
      });
  });
